import React, { useState } from "react";

import Style from "./TaxiRequestComponents.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAddressBook,
  faCalendar,
  faCoins,
  faDollarSign,
  faMapPin,
} from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import { separate } from "./../../Functions/NumberSeprator";
import { TaxiReqApi } from "../../Api/DeliveryBarest";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import { useHistory } from "react-router-dom";
import moment from "moment-jalaali";

const TaxiRequestComponents = ({ data, updateReq }) => {
  const history = useHistory();
  const [loadingState,setLoadingState]=useState(false)
  const OpenMapHandler = (location) => {
    const lat = data.start_lat;
    const lng = data.start_lon;
    // Universal geo link
    const geoUrl = `geo:${lat},${lng}?q=${lat},${lng}`;

    // Backup web link (in case desktop browser)
    const webUrl = `https://maps.google.com/?q=${lat},${lng}`;

    // Try to open geo: (mobile)
    window.location.href = geoUrl;

    // After short delay, fallback for browsers that don't support geo:
    setTimeout(() => {
      window.open(webUrl, "_blank");
    }, 500);
  };
  const acceptHandler = () => {
    setLoadingState(true)
    let info = {
      id: data.id,
      action: "accept",
    };
    TaxiReqApi(info, (res) => {
      if (res.status === 1) {
        succToast("تایید شد! مسافر منتظر شماست.");
        updateReq();
        setLoadingState(false)
        history.push("/taxireq/taxireqcondition");
      } else {
        errorToast(res.message);
        setLoadingState(false)
      }
    });
  };
  return (
    <li className={Style.ComponentHolder}>
      <address className={Style.AddressHolder}>
        <FontAwesomeIcon icon={faMapPin} color="#b00064" />
        <p>مبدا:{data?.routes_description.split("**")[0]}</p>
      </address>
      <address className={Style.AddressHolder}>
        <FontAwesomeIcon icon={faMapPin} color="#b00064" />
        <p>مقصد: {data?.routes_description.split("**")[1]}</p>
      </address>
      {data?.routes_description.split("**")[2] && (
        <address className={Style.AddressHolder}>
          <FontAwesomeIcon
            icon={faMapPin}
            color="#b00064"
            // onClick={OpenMapHandler}
          />
          <p>مقصد دوم: {data?.routes_description.split("**")[2]}</p>
        </address>
      )}
      {data?.description && (
        <address className={Style.AddressHolder}>
          <FontAwesomeIcon icon={faAddressBook} color="#b00064" />
          <p>توضیحات: {data?.description}</p>
        </address>
      )}
      {/* <button className={Style.BtnAddress}>نمایش موقعیت روی نقشه</button> */}
      <p className={Style.passengerHolder}>
        <FontAwesomeIcon icon={faCalendar} color="#15a2fa" />
        {moment.unix(parseInt(data?.request_date)).format("jYYYY/jM/jD--hh:mm")}
      </p>
      <p className={Style.passengerHolder}>
        <FontAwesomeIcon icon={faUser} color="#15a2fa" />
        {data.name}
      </p>
      <p className={Style.PriceHolder}>
        <FontAwesomeIcon icon={faCoins} color="#00d463" />
        {`${separate(data.delivery)} تومان`}
      </p>
      <button className={Style.acceptBtn} onClick={acceptHandler} disabled={loadingState}>
       {loadingState ? "منتظر باشید..." : "قبول درخواست"}
      </button>
    </li>
  );
};

export default TaxiRequestComponents;
